export const menuTitle = { title: "UNIVERSITY", label: "University" };
